export default __webpack_public_path__ + "static/media/CH.3fecd05a.svg";